import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'

import T from '../../SPRINTA/translate/T'

import { date } from '../../libraries/Formatter'

import If from '../../components/atoms/If'
import PlaceHolder from '../../components/atoms/PlaceHolder'
import { Container, Row, Col } from '../../components/atoms/Grid'

import EventTemplate from '../../components/templates/Event'


import { loadEventToken, } from '../../modules/actions/Events'
 
let token = this.token

class Event extends Component {
  

  loadEvent() {
    this.props.loadEventToken(token, true)
  }
 
  componentWillMount() {
    token = this.props.match.params.token
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.login.logonStatus === 'loading')
      return

    //atualiza a página se for alterado o token. Ex: busca
    if(nextProps.match.params.token !== token) {
      token = nextProps.match.params.token
      this.loadEvent()
      return
    }

    if(nextProps.events.event[token]) {
      if(nextProps.events.event[token].status === 'not_found') {
        this.props.goTo('/404')
      }
    }

    if(this.props.events.event[token]) {
      if(nextProps.login.isLogged !== this.props.login.isLogged) 
        this.loadEvent()
    } else {
      this.loadEvent()
    }
  }

  handleSignup(type) {
    let event = this.props.events.event[token].data
    let ml = event.mandatory_login === '1' ? 'inscription' : 'subscription'
    const linkSubscription = '/event/'+ ml +'/'+event.token
    let linkCheckout = null
    if(event.inscription) {
      linkCheckout = window.URL_CHECKOUT + event.inscription.token
    }
    
    if(type === 'uniq') {
      if(event.opened && (event.allow_other === "1" || event.allow_group === "1")) {
        this.props.goTo(linkSubscription)
        return
      }
    }
    
    if(event.inscription && type !== 'other') {
      return window.location.href = linkCheckout
    }
    
    this.props.goTo(linkSubscription)
  }

  render() {

    return (
      <div>
        <If test={!this.props.events.event[token] || this.props.events.event[token].status === 'loading'}>
          <PlaceHolder type='retangle' style={{height: '350px'}} />
          <Container>
            <Row>
              <Col size='8'>
                <PlaceHolder type='retangle' style={{ height: '500px'}} />
              </Col>
              <Col size='4'>
                <Row>
                  <PlaceHolder type='retangle' style={{ height: '250px'}} />
                  <PlaceHolder type='retangle' style={{ height: '100px'}} />
                </Row>
              </Col>
            </Row>
          </Container>
        </If>
        <If test={this.props.events.event[token] && this.props.events.event[token].status === 'done'}>
          <EventTemplate
            event={this.props.events.event[token]}
            handleSignup={ (type) => this.handleSignup(type) }
            isLogged={this.props.login.isLogged}
            />
        </If>

        {/*para ser renderizado pelo phantonjs precisa ser no final do arquivo*/}
        {( this.props.events.event[token] && this.props.events.event[token].status === 'done' && (
          <Helmet>
                <title>SPRINTA | {this.props.events.event[token].data.title}</title>
                <meta property="og:locale" content={T.getLanguage()}/>
                <meta property="og:url" content={`https://app.sprinta.com.br/event/${this.props.events.event[token].data.token}/?lang=${T.getLanguage()}`}/>
                <meta property="og:title" content={T.txt('metatag_event_title', {
                  title: this.props.events.event[token].data.title
                })}/>
                <meta property="og:description" content={T.txt('metatag_event_description', {
                  date: date(this.props.events.event[token].data.date).br,
                  time: this.props.events.event[token].data.hour,
                  city: this.props.events.event[token].data.city,
                  region: this.props.events.event[token].data.state_abbreviation
                })}/>
                <meta property="og:image" content={`${this.props.events.event[token].data.cover_path}`} />
            </Helmet>
        ))}
      </div>
    )
  }
} 

const mapStateToProps = state => ({
  login: state.login,
  events: state.events,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  loadEventToken,
  goHome: () => push('/'),
  goTo: (to) => push(to)
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Event)


// WEBPACK FOOTER //
// ./src/pages/event/index.js